const Entity = `
  id
  name
`;

export default Entity;
